(function () {
    'use strict';

    angular
        .module('app.promotionalImages')
        .controller('PromotionalImageDetailsController', PromotionalImageDetailsController);

    PromotionalImageDetailsController.$inject = [
        '$state', '$stateParams', '$window',
        'bootstrap.dialog', 'common', 'dataservice'
    ];

    function PromotionalImageDetailsController($state, $stateParams, $window, bsDialog, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        var logger = common.logger;
        var $q = common.$q;
        
        vm.cancel = cancel;
        vm.deleteItem = deleteItem;
        vm.isSaving = false;
        vm.save = save;
        vm.item = undefined;
        vm.numberOfUses = 0;
        

        activate();

        function activate() {
            var promises = [getItem(), getCounts()];
           
            return common.$q.all(promises).then(function (data) {
                
            }, function (error) { });
        }

        function cancel() {
            backToList();
        }

        function backToList() {
            $state.go("promotionalimages.list");
        }

        function getCounts() {
            var val = $stateParams.id;
            if (val != '') {
                return dataservice.getItem("api/PromotionalImages/CountsOfUses/" + val)
                    .then(function (response) {
                        vm.numberOfUses = response.data.NumberOfItems;
                    }, function (error) { })
            }
        }

        function deleteItem() {
            return bsDialog.deleteDialog('Promotional Image')
                .then(confirmDelete, function () { });

            function confirmDelete() {
                dataservice.deleteItem("api/PromotionalImages/" + vm.item.Id).then(success).catch(failed);

                function success() {
                    backToList();
                }

                function failed(error) {
                    logger.error(error);
                }
            }
        }

        function getItem() {
            var val = $stateParams.id;
            if (val === '') {
                vm.item = {};
                vm.item.Id = '';
                common.setAuditInfo(vm.item);
                return vm.item;
            }

            return dataservice.getItem("api/PromotionalImages/" + val)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                        common.setAuditInfo(vm.item);
                        
                    } else {
                        logger.warning('Could not find item with id = ' + val);
                        $state.go('404');
                    }
                })
                .catch(function (error) {
                    logger.error('Error while getting item with id = ' + val + '; ' + error);
                    $state.go('404');
                });
        }

        function save() {
            if (vm.item.Id == '') {
                vm.isSaving = true;
                var elmId = "photo";
                var imgInput = document.getElementById(elmId);
                var img = imgInput.files[0];

                if (!img) {
                    common.logger.error("Please choose a file to continue");
                    return;
                }

                var dto = {
                    "AltText": vm.item.AltText,
                    "LongDescription": vm.item.LongDescription == undefined ? null : vm.item.LongDescription
                }
                

               dataservice.postFile('api/PromotionalImages/PostFile', img, dto).then(function (saveResult) {
                    vm.isSaving = false;
                    backToList();
               }).catch(function (error) {
                    vm.isSaving = false;
               });
            }
            else {
                
                var dto = {
                    "Id": vm.item.Id,
                    "AltText": vm.item.AltText,
                    "LongDescription": vm.item.LongDescription
                }

                dataservice.saveItem('api/PromotionalImages/Update', dto).then(function (saveResult) {
                    vm.isSaving = false;
                    backToList();
                }).catch(function (error) {
                    vm.isSaving = false;
                });
            }
            
        }

  
    }
})();
